const CourseStorage = {
    state: {
courseDeletIds:[],
lessonDeletIds:[]
    },
    mutations: {
      SET_DELETE_ID_MUTATION: (state, payload) => {
        state.courseDeletIds = payload
      },
      SET_Lesson_DELETE_ID_MUTATION: (state, payload) => {
        state.lessonDeletIds = payload
      },
    },
    actions: {
        SET_DELETED_COURSE_ID:({commit}, payload) => {
        commit('SET_DELETE_ID_MUTATION', payload)
      },
      SET_DELETED_Lesson_ID:({commit}, payload) => {
        commit('SET_Lesson_DELETE_ID_MUTATION', payload)
      },
    },
    getters: {
        get_course_deleted_id: (state) => {
        return state.courseDeletIds
      },
      get_lesson_deleted_id: (state) => {
        return state.lessonDeletIds
      },
    }
  }
  export default CourseStorage
  